var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 0a7 7 0 110 14A7 7 0 017 0zm-.444 3.152L3.184 6.48a.459.459 0 000 .735.723.723 0 00.887 0L6.333 4.78v5.702c0 .286.32.519.667.519.346 0 .667-.233.667-.52V4.77l2.262 2.446a.723.723 0 00.887 0 .459.459 0 000-.736L7.444 3.152a.723.723 0 00-.888 0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeArrow);
export default ForwardRef;